var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7534 6C10.7534 7.47276 9.52067 8.66667 8 8.66667C6.47933 8.66667 5.24659 7.47276 5.24659 6C5.24659 4.52724 6.47933 3.33333 8 3.33333C9.52067 3.33333 10.7534 4.52724 10.7534 6ZM9.37671 6C9.37671 6.73638 8.76033 7.33333 8 7.33333C7.23967 7.33333 6.6233 6.73638 6.6233 6C6.6233 5.26362 7.23967 4.66667 8 4.66667C8.76033 4.66667 9.37671 5.26362 9.37671 6Z",
    fill: "#027EFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C11.8489 0 15.083 2.54955 16 6C15.083 9.45046 11.8489 12 8 12C4.15106 12 0.916975 9.45046 0 6C0.916975 2.54955 4.15106 0 8 0ZM8 10.6667C4.91923 10.6667 2.30823 8.70542 1.43121 6C2.30823 3.29458 4.91923 1.33333 8 1.33333C11.0808 1.33333 13.6918 3.29458 14.5688 6C13.6918 8.70542 11.0808 10.6667 8 10.6667Z",
    fill: "#027EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.937f665491f6b24b5da7c935282f5c9d.svg";
export { ForwardRef as ReactComponent };